import { useRoot } from "../../contexts/Root";
import { Bar } from "./Bar";

export const BackgroundBar = (): JSX.Element => {
  const {
    theme: { seekBarBackground },
  } = useRoot();

  return <Bar show zIndex={0} color={seekBarBackground} />;
};
